module.exports = __webpack_public_path__ + "img/logo2.355bbc59.png";